import React from 'react';
import classNames from 'classnames';
import NylAlert, { NylAlertTitle } from '../../common/components/NylAlert';
import InfoIcon from '../../common/components/Icons/InfoIcon';

const bodyTextClassname = "nyl-alert__body__text";
const anchorClassname = `${bodyTextClassname}--anchor`;
const strongTextClassname = `${bodyTextClassname}--strong`

const NeedHelpAlertTitle = () => (
  <div className="d-flex align-items-center justify-content-start">
    <div>
      <InfoIcon className="alert__icon" />
    </div>
    <div className="ml-2">
      <NylAlertTitle
        level={3}
        className="nyl-alert__title__text nyl-alert__title__text--with-icon"
      >
        Didn't get the email?
      </NylAlertTitle>
    </div>
  </div>
);

const NeedHelpAlertBody = () => (
  <>
    <ul className={classNames('nyl-alert__body__ul', 'mb-4')}>
      <li className={classNames(bodyTextClassname, 'mt-3')}>
        Double-check that your email address is correct.
      </li>
      <li className={bodyTextClassname}>
        Make sure you're using the email associated with your
        Official NY Lottery account. If you registered an NYL account prior to 2025, however, please create a new account instead.
      </li>
    </ul>
    <p className={classNames(bodyTextClassname, 'mb-0')}>
      Still need help? Visit our{" "}
      <a
        className={classNames(bodyTextClassname, anchorClassname)}
        href='https://nylottery.ny.gov/help-center'
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong className={classNames(bodyTextClassname, strongTextClassname)}>FAQs</strong>
      </a>{" "}
      or contact our friendly customer support team. We're
      here to help you get back to playing!
    </p>
  </>
)

const NeedHelpAlert = () => (
  <NylAlert
    title={<NeedHelpAlertTitle />}
    body={<NeedHelpAlertBody />}
  />
);

export default NeedHelpAlert;
